module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/ants_infobanner02.822a8c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/ants_infobanner02.png
// module id = 7asG
// module chunks = 0